import { Button } from "primereact/button";
import ContactUsSection from "../Components/contactUsSection";

const AboutUs = () => {
    return (
        <>
            <div style={{
                width: "100%",
                backgroundImage: "url('/AboutUsBg.jpg')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
            }} className="flex flex-column justify-content-center gap-5 px-4 md:px-8 py-8" >
                <div className="grid gap-3">
                    <div className="col bg-white py-6 px-4 md:px-8">
                        <div className="flex flex-column gap-5">
                            <p className="m-0 text-xl text-center md:text-left" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >OUR MISSION</p>
                            <p className="m-0 text-5xl font-bold md:w-30rem text-center md:text-left" style={{ color: "#2D3967", textWrap: "wrap" }} >
                                A Brand New Physical Therapy Experience
                            </p>
                            <p className="m-0 text-lg flex-grow-1" style={{ color: "#727A99", textWrap: "wrap" }} >
                                Mobithera is on a mission to redefine physical therapy by merging clinical expertise with cutting-edge technology. Our platform delivers intelligent, personalized exercise programs tailored to individual needs, powered by real-time motion analysis and AI.
                            </p>
                        </div>
                    </div>
                    <div className="col bg-white py-6 px-4 md:px-8">
                        <div className="flex flex-column gap-5">
                            <p className="m-0 text-xl text-center md:text-left" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >OUR VISION</p>
                            <p className="m-0 text-5xl font-bold text-center md:text-left md:w-30rem" style={{ color: "#2D3967" }} >
                                Where AI Meets Human Expertise
                            </p>
                            <p className="m-0 text-lg flex-grow-1" style={{ color: "#727A99", textWrap: "wrap" }} >
                                Mobithera is on a mission to redefine physical therapy by merging clinical expertise with cutting-edge technology. Our platform delivers intelligent, personalized exercise programs tailored to individual needs, powered by real-time motion analysis and AI.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{
                width: "100%",
                backgroundImage: "url('/Circles.png')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
            }} className="flex flex-column justify-content-center gap-8 px-4 md:px-8 py-8" >
                <div className="flex flex-column align-items-center">
                    <p className="m-0 text-xl text-center" style={{ color: "#727A99", letterSpacing: "4px" }} >OUR STORY</p>
                    <p className="flex flex-wrap justify-content-center align-items-center m-0 text-center" style={{ color: "#2D3967", fontSize: "3.25rem", fontWeight: 700 }} >The Story Behind <span className="flex mx-3 align-items-center gap-1" style={{color: "#E3506B"}}>Mobithera<span style={{fontSize: "1.5rem", marginTop: "-0.5rem"}}>™</span></span></p>
                </div>
                <div className="grid gap-8">
                    <div className="col">
                        <p className="m-0 text-xl" style={{ color: "#727A99", textWrap: "wrap" }}>
                            Mobithera was born from a simple, recurring challenge faced by physiotherapists:
                            <br />
                            <b>How do we ensure that patients actually do their exercises at home—and do them right?</b>
                            <br />
                            <br />
                            We’ve seen it countless times that physiotherapists are suffering from patient non-adherence. A patient walks out of the clinic with a list of exercises, unmotivated and uncertain. A week later, they return frustrated: unsure if they did them correctly, confused about the instructions, or simply gave up.
                            That’s when the idea was born.
                            <br />
                            <br />
                            What if we could build a system that doesn’t just prescribe exercises, but guides, monitors, and motivates—right from the patient’s own home?
                        </p>
                    </div>
                    <div className="col">
                        <p className="m-0 text-xl" style={{ color: "#727A99", textWrap: "wrap" }}>
                            Combining clinical insight with digital innovation, Mobithera was created to transform rehabilitation into a personalized, interactive, and data-driven experience. No more one-size-fits-all handouts. No more guesswork. Just smart, accessible, and empowering care for everyone.
                            <br />
                            <br />
                            It wasn’t just about creating a solution for physical therapists putting patients at the center of the experience played an important role in shaping Mobithera. For example, many younger patients simply don’t have the time to visit clinics for prescribed exercises, while elderly individuals or those with severe conditions often face real challenges getting to a clinic at all. These realities were key factors in the creation of Mobithera.
                        </p>
                    </div>
                </div>
            </div>
            <div className="flex flex-wrap justify-content-evenly align-items-center px-4 md:px-8 py-5 gap-5"
                style={{ backgroundColor: "#2D3967", width: "100%", minHeight: "20vh" }}>
                <p className="text-white m-0" style={{ fontSize: "1.75rem", fontWeight: 700 }}>
                    “<span className="mr-1 gap-1" style={{color: "#E3506B"}}>Mobithera<span style={{fontSize: "1.5rem", marginTop: "-0.5rem"}}>™</span></span> isn't just an app. It’s a commitment to better healing—for everyone.”
                </p>
            </div>
            <ContactUsSection />
            <div className="flex flex-wrap justify-content-evenly align-items-center px-4 md:px-8 py-5 gap-5"
                style={{ background: "linear-gradient(90deg, #993648 0%, #E3506B 100%)", width: "100%", minHeight: "20vh" }}>
                <div className="flex flex-wrap justify-content-between align-items-center w-full gap-5">
                    <p className="text-white m-0 w-30rem flex-grow-1" style={{ fontSize: "1.75rem", fontWeight: 700 }}>
                        Please contact us for further information or to begin your journey with us!
                    </p>
                    <Button label="Contact Us"
                        style={{
                            color: "#E3506B",
                            backgroundColor: "#FFFFFF",
                            borderRadius: "10px",
                            fontWeight: "bold",
                            height: "2.5rem",
                        }} className="flex-grow-1 w-15rem xl:flex-grow-0" />
                </div>
            </div>
        </>
    )
}

export default AboutUs;